import { render, staticRenderFns } from "./NoStatistics.vue?vue&type=template&id=f6569530&"
import script from "./NoStatistics.vue?vue&type=script&lang=js&"
export * from "./NoStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports